<div [matMenuTriggerFor]="menu" class="avatar-container">
  <app-avatar-image [size]="40" [avatar]="avatar" *ngIf="avatar"></app-avatar-image>
  <mat-menu #menu="matMenu">
    <app-menu-contents></app-menu-contents>
  </mat-menu>
</div>
